import $ from 'jquery';
import ClipboardJS from 'clipboard';
import Toast from './toasts';
import { ToastType } from '../types/toast';
export default class CopyInputValue {
    static init() {
        $('.js__data-copy').each((i, element) => {
            const clipboardData = new ClipboardJS(element);
            this.showSuccess(clipboardData, $(element));
        });
    }
    static showSuccess(clipboard, $target) {
        clipboard.on('success', () => {
            Toast.callToast(ToastType.Success, $target.data('success-description'), $target.data('success-title'), {
                timeOut: 3000,
            });
        });
    }
}
